import { render } from "./ResultTableItemError.vue?vue&type=template&id=1a197744"
import script from "./ResultTableItemError.vue?vue&type=script&lang=js"
export * from "./ResultTableItemError.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentIFAS\\_work\\45\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__